import { FC } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { KTSVG } from '../../../helpers'
import { requestPassword } from '../../../../app/modules/auth/redux/AuthCRUD'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import { UserModel } from '../../../../app/modules/auth/models/UserModel'
import { showErrorAlert } from '../../../../app/helpers/alert'
import { useConfirmAction } from '../../../../app/hooks/utils/useConfirmAction'
import { UserRole } from '../../../../app/constants/roles'
import { hasRole } from '../../../../app/utils/permissions'
import { useUserProfileContext } from '../../../../app/context/UserProfileContext'

type Props = {
  open: boolean
  // Armando 2026-09-10: el header controla el open/close del popup y el click-outside vive
  // en HeaderWrapper. Aqui lo unico que sabemos es que el usuario ya eligio una opcion, asi
  // que dejamos que el padre cierre el menu; es opcional por si algun consumidor legado
  // renderiza el menu sin owner.
  onClose?: () => void
}
const HeaderUserMenu: FC<Props> = ({ open, onClose }) => {
  const user = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const confirm = useConfirmAction()
  const history = useHistory()
  const isFinalUser = hasRole(user, UserRole.FINAL_USER)
  const {setSearchParams: setParamasData} = useUserProfileContext()

  const handleOnChangePassword = async () => {
    let isConfirm = await confirm({ title: 'Change Your Password', message: `A reset link will be sent to your registered email ${user.email}`, btnTextAction: 'Reset'  })
    if (isConfirm) {
      // Cierra el popup en cuanto el usuario confirma; el confirm ya es un modal aparte y
      // el flujo posterior redirige a /logout, asi que mantenerlo abierto solo estorbaba.
      onClose?.()
      requestPassword(user.email)
        .then((result) => {
          // Defensive: backend deploys alongside this change. Treat anything
          // that is not an explicit `false` as success (older backend returns a
          // truthy string / relies on HTTP 200), and fall back to sensible copy
          // if `message` is absent so we never render `undefined`.
          const isSuccess = result?.data?.success !== false
          const message =
            result?.data?.message ||
            (isSuccess
              ? 'Please check your inbox to reset your password.'
              : "This feature isn't available right now. Please try again later.")
          if (isSuccess) {
            showErrorAlert({
              title: 'Action Complete',
              message,
            })
            history.push('/logout')
          } else {
            showErrorAlert({
              title: 'Action Unavailable',
              message,
            })
          }
        })
        .catch((error: any) => {
          const statusCode = error?.response?.status || 500
          showErrorAlert({
            title: 'Password Reset Unavailable',
            message:
              "We couldn't send the password reset link at this time. Please try again in a few minutes.",
            errorCode: `AUTH_FORGOT_${statusCode}`,
          })
        })
    }
  }

  const handleOnMyProfile = () => {
    setParamasData({userSelected: ''});
    // Members open MY PROFILE on the read-only profile landing (/biography),
    // not the edit form. The edit form is still reachable from the "Edit"
    // button inside /biography.
    history.push('/biography');
    onClose?.()
  }

  // PR-I-65: navega a /notifications con ?settings=1 para que la pagina
  // abra el modal directo. Elegimos query param (no estado global / no
  // Context) porque el header no debe conocer el modal; asi el acoplamiento
  // es solo la URL, que ya es contrato publico del router.
  const handleOnNotificationSettings = () => {
    history.push('/notifications?settings=1');
    onClose?.()
  }

  return (
    <div className={`menu menu-sub menu-sub-dropdown custom-user-menu ${open ? 'show' : ''}`} data-kt-menu="true" id='user_menu'>
      {/* UPGRADE SECTION */}
      <div className='custom-user-menu__upgrade'>
        <div className='custom-user-menu__upgrade-text'>Coming soon</div>
        {/* <div className='custom-user-menu__upgrade-text'>Upgrade to Electi ∞</div> */}
        {/*  <div className='custom-user-menu__upgrade-price'>$ 5.000 + 20.000 Credits</div> */}
      </div>

      {/* MY PROFILE */}
      <div onClick={handleOnMyProfile} className={`custom-user-menu__item custom-user-menu__item--profile ${isFinalUser ? '' : 'd-none'}`}>
        <div className='custom-user-menu__icon'>
          <KTSVG path={'/media/svg/nobilis/user-white.svg'} />
        </div>
        <span className='custom-user-menu__text'>MY PROFILE</span>
      </div>

      {/* MESSAGES */}
      {/* <div className='custom-user-menu__item'>
        <div className='custom-user-menu__icon'>
          <KTSVG path={'/media/svg/nobilis/message.svg'} />
        </div>
        <span className='custom-user-menu__text custom-user-menu__text--dark'>MESSAGES</span>
      </div> */}

      {/* NOTIFICATION SETTINGS (PR-I-65) */}
      <div className='custom-user-menu__item' onClick={handleOnNotificationSettings}>
        <div className='custom-user-menu__icon'>
          <KTSVG path={'/media/svg/nobilis/message.svg'} />
        </div>
        <span className='custom-user-menu__text custom-user-menu__text--dark'>NOTIFICATION SETTINGS</span>
      </div>

      {/* CHANGE PASSWORD */}
      <div className='custom-user-menu__item' onClick={handleOnChangePassword}>
        <div className='custom-user-menu__icon'>
          <KTSVG path={'/media/svg/nobilis/change_pass.svg'} />
        </div>
        <span className='custom-user-menu__text custom-user-menu__text--dark'>CHANGE PASSWORD</span>
      </div>

      {/* LOGOUT */}
      <Link to='/logout' className='custom-user-menu__item' onClick={onClose}>
        <div className='custom-user-menu__icon'>
          <KTSVG path={'/media/svg/nobilis/logout.svg'} />
        </div>
        <span className='custom-user-menu__text custom-user-menu__text--logout'>LOGOUT</span>
      </Link>
    </div>
  )
}

export { HeaderUserMenu }
